export enum AuthenticationState {
  UNAUTHENTICATED = 'Unauthenticated',
  AUTHENTICATING = 'Authenticating',
  AUTHENTICATED = 'Authenticated',
  TOKEN_EXPIRED = 'TokenExpired',
  UNAUTHENTICATING = 'Unauthenticating',
  CONFIRM_SENT = 'Confirm sent'
}
